import { render, staticRenderFns } from "./OverlayRoomInfos.vue?vue&type=template&id=b1530140&scoped=true"
import script from "./OverlayRoomInfos.vue?vue&type=script&lang=js"
export * from "./OverlayRoomInfos.vue?vue&type=script&lang=js"
import style0 from "./OverlayRoomInfos.vue?vue&type=style&index=0&id=b1530140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1530140",
  null
  
)

export default component.exports